import { render, staticRenderFns } from "./cc-modal-product-details.vue?vue&type=template&id=1b3ec42d"
import script from "./cc-modal-product-details.vue?vue&type=script&lang=js"
export * from "./cc-modal-product-details.vue?vue&type=script&lang=js"
import style0 from "./cc-modal-product-details.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports